<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8159 9.22727C20.938 9.76287 21 10.3117 21 10.8636H13.6364V3.5C14.1883 3.5 14.7371 3.56205 15.2727 3.68412C15.6755 3.77593 16.0708 3.90168 16.4543 4.06052C17.3477 4.43058 18.1595 4.97298 18.8432 5.65676C19.527 6.34054 20.0694 7.1523 20.4395 8.04569C20.5983 8.42918 20.7241 8.82448 20.8159 9.22727ZM19.1249 9.22727C19.0688 9.03924 19.003 8.85386 18.9277 8.6719C18.6399 7.97704 18.218 7.34567 17.6862 6.81384C17.1543 6.28202 16.523 5.86015 15.8281 5.57233C15.6461 5.49696 15.4608 5.43117 15.2727 5.37511V9.22727H19.1249Z" fill="black"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 14.1364C3 10.0695 6.29681 6.77273 10.3636 6.77273C10.9156 6.77273 11.4644 6.83477 12 6.95685V12.5H17.5432C17.6652 13.0356 17.7273 13.5844 17.7273 14.1364C17.7273 18.2032 14.4305 21.5 10.3636 21.5C6.29681 21.5 3 18.2032 3 14.1364ZM15.9302 14.1364H10.3636V8.56984C7.28933 8.56984 4.79712 11.0621 4.79712 14.1364C4.79712 17.2107 7.28933 19.7029 10.3636 19.7029C13.4379 19.7029 15.9302 17.2107 15.9302 14.1364Z" fill="black"/>
  </svg>
</template>

<script>
export default {
  name: 'chartIcon'
}
</script>

<style scoped>

</style>
